import PhoneInputComponent, { Country } from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import { connect, ConnectedProps } from 'react-redux';
import '../../resources/css/fields.css';

// Import locale files for all 4 languages
import de from 'react-phone-number-input/locale/de.json';
import en from 'react-phone-number-input/locale/en.json';
import fr from 'react-phone-number-input/locale/fr.json';
import it from 'react-phone-number-input/locale/it.json';
import { ApplicationState } from '../../store/types';

type ReduxProps = ConnectedProps<typeof connector>;

interface IProps {
    value?: string;
    defaultCountry?: Country;
    error?: string;
    placeholder?: string;
    disabled?: boolean;
    onClick?: () => void;
    onFocus?: () => void;
    onChange?: (value?: string) => void;
}

type Props = IProps & ReduxProps;

/**
 * Component that represents an international phone number input
 * with country selection and validation
 *
 * Props:
 *  - value: the phone number value (E.164 format)
 *  - defaultCountry: default country code (ISO 3166-1 alpha-2)
 *  - error: error message to display
 *  - placeholder: placeholder text
 *  - disabled: whether the input is disabled
 *  - onChange: callback when value changes
 *  - onClick: callback when input is clicked
 *  - onFocus: callback when input is focused
 */
function PhoneInput({
    value,
    defaultCountry,
    error,
    placeholder,
    disabled,
    onChange,
    onClick,
    onFocus,
    language,
}: Props) {
    // Map language to locale labels
    const locales: { [key: string]: any } = {
        fr, en, de, it
    };
    const labels = locales[language] || en;

    const handleChange = (phoneValue?: string) => {
        if (onChange) {
            onChange(phoneValue);
        }
    };

    return (
        /* eslint-disable-next-line jsx-a11y/click-events-have-key-events,
        jsx-a11y/no-static-element-interactions */
        <div className="__textfield-parent" onClick={onClick} onFocus={onFocus}>
            <div className={`__textfield-content __phone-input-wrapper ${error ? '__textfield-content-error' : ''}`}>
                <PhoneInputComponent
                    value={value}
                    onChange={handleChange}
                    defaultCountry={defaultCountry}
                    international
                    withCountryCallingCode
                    labels={labels}
                    placeholder={placeholder}
                    disabled={disabled}
                    className="__phone-input"
                />
            </div>
            {
                error
                    ? <p className="__textfield-error">{error}</p>
                    : null
            }
        </div>
    );
}

const mapStateToProps = (store: ApplicationState) => ({
    language: store.translation.language,
});

const connector = connect(mapStateToProps);

export default connector(PhoneInput);
